import React, { useEffect, useState } from 'react';

import { log } from './services/utils';

import { getAppInfo } from './api/nora/auth';

import { Provider as AuthProvider } from './contexts/AuthContext';
import { Provider as UIProvider } from './contexts/UIContext';

import Router from './components/Router';
import ApiErrorAlert from './components/Shared/ApiErrorAlert';

import './app.css';
import './calendar-overrides.css';
import 'react-datepicker/dist/react-datepicker.css';

const App = () => {
	const [ appLoading, setAppLoading ] = useState( true );

	useEffect( () => {
		( async () => {
			try {
				sessionStorage.clear(); // clear out any lingering tokens

				const { app_Version: appVersion } = await getAppInfo();
				const currentVersion = localStorage.getItem( 'appVersion' );

				if ( !currentVersion || JSON.parse( currentVersion ) !== appVersion ) {
					localStorage.setItem( 'appVersion', JSON.stringify( appVersion ) );
					window.location.reload( true );
				}

				setAppLoading( false );
			} catch ( error ) {
				console.error( error );
			}
		} )();
	}, [] );

	if ( appLoading ) {
		return null;
	}

	return (
		<div id="app">
			{ log( 'app' ) }
			<AuthProvider>
				<UIProvider>
					<Router />
					<ApiErrorAlert />
				</UIProvider>
			</AuthProvider>
		</div>
	);
};

const AppWrapper = () => <App />;

export default AppWrapper;
